module.exports = __webpack_public_path__ + "06_hair_brown.ff6abc46.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/06_hair_brown.png
// module id = c1FK
// module chunks = 0